import { render, staticRenderFns } from "./ModalAdminAdd.vue?vue&type=template&id=5894d328&scoped=true&lang=pug&"
import script from "./ModalAdminAdd.vue?vue&type=script&lang=ts&"
export * from "./ModalAdminAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAdminAdd.vue?vue&type=style&index=0&id=5894d328&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5894d328",
  null
  
)

export default component.exports